import { LS_KEY } from "constants.js";

export function logout() {
    localStorage.removeItem(LS_KEY);
}
